export default "__VITE_ASSET__BqH0zbSt__"